
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-mobile-menu]').forEach(btn => {
    btn.addEventListener('click', () => {
      const nav = document.querySelector('.ma-nav');
      if (nav) nav.style.display = nav.style.display === 'block' ? '' : 'block';
    });
  });

  initProductForms(document);
  initFaqItems(document);
  initCartQuantityLimits(document);
  initCollectionDefaultSort();
});

document.addEventListener('shopify:section:load', event => {
  initProductForms(event.target);
  initFaqItems(event.target);
  initCartQuantityLimits(event.target);
});

/*function initCollectionDefaultSort() {
  const collectionRoot = document.querySelector('[data-collection-default-sort]');
  if (!collectionRoot) return;

  const defaultSort = collectionRoot.dataset.collectionDefaultSort;
  if (!defaultSort) return;

  const url = new URL(window.location.href);
  if (url.searchParams.has('sort_by')) return;

  url.searchParams.set('sort_by', defaultSort);
  window.location.replace(url.toString());
}*/

function initFaqItems(root) {
  root.querySelectorAll('.ma-faq-item').forEach(details => {
    if (details.dataset.faqReady === 'true') return;

    const summary = details.querySelector('summary');
    const body = details.querySelector(':scope > div') || (summary && summary.nextElementSibling);
    if (!summary || !body) return;

    details.dataset.faqReady = 'true';
    details.classList.add('is-js');
    let animation = null;

    if (details.open) {
      details.classList.add('is-expanded');
      body.style.height = 'auto';
    } else {
      body.style.height = '0px';
    }

    summary.addEventListener('click', event => {
      event.preventDefault();

      if (animation) animation.cancel();

      if (details.open) {
        const startHeight = body.offsetHeight;
        details.classList.remove('is-expanded');
        body.style.height = `${startHeight}px`;

        animation = body.animate([
          { height: `${startHeight}px`, opacity: 1 },
          { height: '0px', opacity: 0 }
        ], {
          duration: 260,
          easing: 'cubic-bezier(.25, .8, .25, 1)'
        });

        animation.onfinish = () => {
          details.open = false;
          body.style.height = '0px';
          animation = null;
        };
      } else {
        details.open = true;
        details.classList.add('is-expanded');
        body.style.height = '0px';
        const endHeight = body.scrollHeight;

        animation = body.animate([
          { height: '0px', opacity: 0 },
          { height: `${endHeight}px`, opacity: 1 }
        ], {
          duration: 300,
          easing: 'cubic-bezier(.25, .8, .25, 1)'
        });

        animation.onfinish = () => {
          body.style.height = 'auto';
          animation = null;
        };
      }
    });
  });
}

function initCartQuantityLimits(root) {
  root.querySelectorAll('.ma-cart__form').forEach(form => {
    if (form.dataset.cartQuantityReady === 'true') return;
    form.dataset.cartQuantityReady = 'true';

    form.querySelectorAll('input[name="updates[]"]').forEach(input => {
      const clamp = () => {
        const max = input.max ? parseInt(input.max, 10) : null;
        const rawValue = parseInt(input.value || '0', 10);
        const value = Number.isNaN(rawValue) ? 0 : Math.max(0, rawValue);
        input.value = max ? Math.min(value, max) : value;
      };

      clamp();
      input.addEventListener('input', clamp);
      input.addEventListener('change', clamp);
    });
  });
}

function initProductForms(root) {
  root.querySelectorAll('.ma-product-form').forEach(form => {
    if (form.dataset.productFormReady === 'true') return;
    form.dataset.productFormReady = 'true';

    const variantInput = form.querySelector('[data-variant-input]');
    const optionGroups = form.querySelector('[data-option-groups]');
    const variantsScript = form.querySelector('[data-product-variants-json]');
    const submit = form.querySelector('.ma-product__submit');
    const qty = form.querySelector('input[name="quantity"]');
    const mainMedia = document.querySelector('.ma-product__media');
    const mainImage = document.querySelector('.ma-product__media img');
    let currentColorOptionIndex = -1;

    let variants = [];
    if (variantsScript) {
      try {
        variants = JSON.parse(variantsScript.textContent)
          .filter(Boolean)
          .filter(variant => String(variant.title || '').trim().toLowerCase() !== 'escolha')
          .map(variant => ({
            ...variant,
            options: (variant.options || []).filter(option => option !== null && option !== '')
          }));
      } catch (error) {
        variants = [];
      }
    }

    const normalizeText = value => String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

    const productThumbs = () => Array.from(document.querySelectorAll('[data-product-thumb]'));
    const visibleProductThumbs = () => productThumbs().filter(thumb => !thumb.hidden);
    const variantById = new Map(variants.map(variant => [String(variant.id), variant]));

    const thumbVariantIds = thumb => String(thumb.dataset.variantIds || '').split(',').filter(Boolean);

    const thumbColorValue = thumb => {
      if (currentColorOptionIndex < 0) return '';
      const variant = thumbVariantIds(thumb).map(id => variantById.get(id)).find(Boolean);
      return variant && variant.options ? variant.options[currentColorOptionIndex] : '';
    };

    const hideDuplicateVariantThumbs = () => {
      if (currentColorOptionIndex < 0) return;

      const seenColors = new Set();
      productThumbs().forEach(thumb => {
        const ids = thumbVariantIds(thumb);
        const colorValue = thumbColorValue(thumb);
        const colorKey = normalizeText(colorValue);

        if (!ids.length || !colorKey) {
          thumb.hidden = false;
          thumb.removeAttribute('aria-hidden');
          thumb.removeAttribute('tabindex');
          return;
        }

        const isDuplicate = seenColors.has(colorKey);
        thumb.hidden = isDuplicate;
        thumb.dataset.variantColor = colorKey;

        if (isDuplicate) {
          thumb.setAttribute('aria-hidden', 'true');
          thumb.setAttribute('tabindex', '-1');
        } else {
          seenColors.add(colorKey);
          thumb.removeAttribute('aria-hidden');
          thumb.removeAttribute('tabindex');
        }
      });
    };

    const matchingThumbForVariant = variant => {
      if (!variant) return null;
      const thumbs = visibleProductThumbs();
      const byVariant = thumbs.find(thumb => {
        const ids = thumbVariantIds(thumb);
        return ids.includes(String(variant.id));
      });
      if (byVariant) return byVariant;

      const colorValue = currentColorOptionIndex >= 0 ? variant.options[currentColorOptionIndex] : '';
      const colorTerms = normalizeText(colorValue).split(' ').filter(Boolean);
      if (!colorTerms.length) return null;

      return thumbs.find(thumb => thumb.dataset.variantColor === normalizeText(colorValue))
        || thumbs.find(thumb => {
          const haystack = normalizeText(`${thumb.dataset.imageAlt || ''} ${thumb.dataset.productThumb || ''}`);
          return colorTerms.every(term => haystack.includes(term));
        });
    };

    const showVariantImage = variant => {
      if (!mainImage || !variant) return;
      const matchedThumb = matchingThumbForVariant(variant);
      const nextUrl = (matchedThumb && matchedThumb.dataset.productThumb) || variant.featuredImage;
      if (!nextUrl) return;
      if (mainImage.getAttribute('src') === nextUrl || mainImage.src === nextUrl) return;

      if (mainMedia) mainMedia.classList.add('is-changing');
      window.setTimeout(() => {
        mainImage.src = nextUrl;
        mainImage.removeAttribute('srcset');
      }, 120);
      mainImage.onload = () => {
        if (mainMedia) mainMedia.classList.remove('is-changing');
      };

      productThumbs().forEach(item => {
        item.classList.toggle('is-active', item.dataset.productThumb === nextUrl);
      });
    };

    if (optionGroups && variantInput && variants.length) {
      let selectedVariant = variants.find(variant => String(variant.id) === String(variantInput.value))
        || variants.find(variant => variant.available)
        || variants[0];
      let selectedOptions = selectedVariant && selectedVariant.options ? selectedVariant.options.slice() : [];
      const isColorButton = button => {
        const name = String(button.dataset.optionName || '').trim().toLowerCase();
        return name.includes('cor') || name.includes('color');
      };
      const colorButton = optionGroups.querySelector('[data-option-name*="Cor"], [data-option-name*="cor"], [data-option-name*="Color"], [data-option-name*="color"]');
      const colorOptionIndex = colorButton ? parseInt(colorButton.dataset.optionIndex, 10) : -1;
      currentColorOptionIndex = colorOptionIndex;
      hideDuplicateVariantThumbs();

      const exactVariant = () => variants.find(variant =>
        variant.options.every((option, index) => selectedOptions[index] === option)
      );

      const bestVariantFor = (button) => {
        const index = parseInt(button.dataset.optionIndex, 10);
        const value = button.dataset.optionValue;
        const nextOptions = selectedOptions.slice();
        nextOptions[index] = value;

        if (isColorButton(button)) {
          return variants.find(variant =>
            variant.available
            && variant.options[index] === value
            && variant.options.every((option, optionIndex) => {
              return optionIndex === index || !nextOptions[optionIndex] || nextOptions[optionIndex] === option;
            })
          ) || variants.find(variant =>
            variant.available && variant.options[index] === value
          ) || variants.find(variant =>
            variant.options[index] === value
          );
        }

        return variants.find(variant =>
          variant.available && variant.options.every((option, optionIndex) => nextOptions[optionIndex] === option)
        ) || variants.find(variant =>
          variant.available
          && variant.options[index] === value
          && (colorOptionIndex < 0 || !selectedOptions[colorOptionIndex] || variant.options[colorOptionIndex] === selectedOptions[colorOptionIndex])
        ) || variants.find(variant =>
          variant.options[index] === value
        );
      };

      const canSelectValue = button => {
        const index = parseInt(button.dataset.optionIndex, 10);
        const value = button.dataset.optionValue;

        if (isColorButton(button)) {
          return variants.some(variant => variant.available && variant.options[index] === value);
        }

        return variants.some(variant => {
          if (!variant.available || variant.options[index] !== value) return false;
          return colorOptionIndex < 0 || !selectedOptions[colorOptionIndex] || variant.options[colorOptionIndex] === selectedOptions[colorOptionIndex];
        });
      };

      const setPurchaseState = (canBuy, variant) => {
        variantInput.disabled = !canBuy;
        if (variant) variantInput.value = variant.id;

        const maxQty = variant && variant.inventoryManagement && variant.inventoryPolicy === 'deny' && variant.inventoryQuantity > 0
          ? variant.inventoryQuantity
          : null;

        form.querySelectorAll('[data-qty]').forEach(button => {
          button.disabled = !canBuy;
        });
        if (qty) {
          qty.disabled = !canBuy;
          if (maxQty) {
            qty.max = String(maxQty);
            if (parseInt(qty.value || '1', 10) > maxQty) qty.value = maxQty;
          } else {
            qty.removeAttribute('max');
          }
        }
        if (submit) {
          submit.disabled = !canBuy;
          submit.textContent = canBuy ? 'Adicionar ao carrinho' : 'Sem estoque';
        }
        if (canBuy) showVariantImage(variant);
      };

      const updateOptionState = () => {
        optionGroups.querySelectorAll('[data-option-value]').forEach(button => {
          const index = parseInt(button.dataset.optionIndex, 10);
          const isSelected = selectedOptions[index] === button.dataset.optionValue;
          button.classList.toggle('is-selected', isSelected);
          button.disabled = !canSelectValue(button);
        });

        const variant = exactVariant();
        setPurchaseState(Boolean(variant && variant.available), variant);
      };

      optionGroups.addEventListener('click', event => {
        const button = event.target.closest('[data-option-value]');
        if (!button || !optionGroups.contains(button) || button.disabled) return;

        const index = parseInt(button.dataset.optionIndex, 10);
        const variant = bestVariantFor(button);
        selectedOptions[index] = button.dataset.optionValue;
        if (variant) selectedOptions = variant.options.slice();
        updateOptionState();
      });

      updateOptionState();
    }

    form.querySelectorAll('.ma-variant-pill').forEach(button => {
      button.addEventListener('click', () => {
        if (!variantInput || button.disabled) return;
        form.querySelectorAll('.ma-variant-pill').forEach(item => {
          item.classList.remove('is-selected');
        });
        button.classList.add('is-selected');
        variantInput.value = button.dataset.variantId;
      });
    });

    form.querySelectorAll('[data-qty]').forEach(button => {
      button.addEventListener('click', () => {
        if (!qty || button.disabled) return;
        const max = qty.max ? parseInt(qty.max, 10) : null;
        const rawNext = Math.max(1, parseInt(qty.value || '1', 10) + parseInt(button.dataset.qty, 10));
        const next = max ? Math.min(rawNext, max) : rawNext;
        qty.value = next;
      });
    });

    if (qty) {
      qty.addEventListener('change', () => {
        const max = qty.max ? parseInt(qty.max, 10) : null;
        const value = Math.max(1, parseInt(qty.value || '1', 10));
        qty.value = max ? Math.min(value, max) : value;
      });
    }
  });

  root.querySelectorAll('[data-product-thumb]').forEach(thumb => {
    if (thumb.dataset.productThumbReady === 'true') return;
    thumb.dataset.productThumbReady = 'true';

    thumb.addEventListener('click', event => {
      const mainMedia = document.querySelector('.ma-product__media');
      const mainImage = document.querySelector('.ma-product__media img');
      if (!mainImage) return;

      event.preventDefault();
      if (mainMedia) mainMedia.classList.add('is-changing');
      window.setTimeout(() => {
        mainImage.src = thumb.dataset.productThumb;
        mainImage.removeAttribute('srcset');
      }, 120);
      mainImage.onload = () => {
        if (mainMedia) mainMedia.classList.remove('is-changing');
      };
      document.querySelectorAll('[data-product-thumb]').forEach(item => {
        item.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
    });
  });
}
